export const getAppBasedEnvironment = () => {
  if (process.env.NEXT_PUBLIC_APP_ENV === 'production') {
    return 'prod';
  }

  if (process.env.NEXT_PUBLIC_APP_ENV === 'staging') {
    return 'qa';
  }

  if (process.env.NEXT_PUBLIC_APP_ENV === 'local') {
    return 'dev';
  }

  return undefined;
};
